export const POSTURE_TEMPLATES_LIST_PATH = '/secure/posture-templates'
export const POSTURE_TEMPLATE_PATH = '/secure/posture-templates/:templateId'

export const SECURE_POSTURE_TAB_KEYS = {
  AUDIT: 'audit',
  PROTECT: 'protect',
}
export const SECURE_POSTURE_PATH = '/secure/security-posture/:companySelectorId?'
export const SECURE_POSTURE_COMPANY_PATH = '/secure/security-posture/:companySelectorId?/:tabKey'
export const SECURE_POSTURE_CHECK_PATH = `/secure/security-posture/:companySelectorId/${SECURE_POSTURE_TAB_KEYS.AUDIT}/:securityCheckType`

export const SECURE_ALERTS_PATH = '/secure/alerts/:companySelectorId?'

export const INTEGRATIONS_PATH = '/integrations/:companySelectorId?'

export const SECURE_POLICIES_PATH = '/secure/policy-management/policies/:companySelectorId?' // This will be for Policy Management instead
export const SECURE_POLICIES_ROOT_PATH = '/secure/policy-management/policies' // This will be for policy management instead

export const POLICY_TEMPLATE_LIST_PATH = '/secure/policy-management/templates/:templateId' // This will be for Policy Templates
export const POLICY_TEMPLATE_PATH = '/secure/policy-management/templates' // This will be for Policy Templates

export const POLICY_MANAGEMENT_NAMED_LOCATIONS_PATH = '/secure/policy-management/named-locations'

export const ENGAGE_ACTIONS_PATH = '/engage/user-management/:companySelectorId?'
export const ENGAGE_ACTION_LOG_PATH = '/engage/action-log/:companySelectorId?'

export const DEFENDER_POLICIES_ROOT_PATH = '/secure/defender/policies'
export const DEFENDER_POLICIES_PATH = '/secure/defender/policies/:companySelectorId?'

export const DEFENDER_TEMPLATES_PATH = '/secure/defender/templates'

export const INTUNE_DEVICE_POLICIES_ROOT_PATH = '/secure/intune/device-management/policies'
export const INTUNE_DEVICE_POLICIES_PATH = '/secure/intune/device-management/policies/:companySelectorId?'
export const INTUNE_DEVICE_TEMPLATES_PATH = '/secure/intune/device-management/templates'

export const INTUNE_DEPLOYMENT_PROFILES_ROOT_PATH = '/secure/intune/onboarding/deployment-profiles'
export const INTUNE_DEPLOYMENT_PROFILES_PATH = '/secure/intune/onboarding/deployment-profiles/:companySelectorId?'
export const INTUNE_DEPLOYMENT_PROFILES_TEMPLATES_PATH = '/secure/intune/onboarding/templates'
